import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import PageTracker from "@/components/PageTracker";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shows from "@/pages/Shows";
import ShowDetail from "@/pages/ShowDetail";
import Episodes from "@/pages/Episodes";
import Sponsors from "@/pages/Sponsors";
import Membership from "@/pages/Membership";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Espanol from "@/pages/Espanol";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <PageTracker />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: { background: "#0F0F0F", border: "1px solid rgba(255,255,255,0.1)", color: "white" },
            }}
          />
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/shows" element={<Layout><Shows /></Layout>} />
            <Route path="/shows/:slug" element={<Layout><ShowDetail /></Layout>} />
            <Route path="/episodes" element={<Layout><Episodes /></Layout>} />
            <Route path="/sponsors" element={<Layout><Sponsors /></Layout>} />
            <Route path="/membership" element={<Layout><Membership /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/espanol" element={<Layout><Espanol /></Layout>} />
            <Route path="/svn-espanol" element={<Layout><Espanol /></Layout>} />
            <Route path="/admin/login" element={<Layout><AdminLogin /></Layout>} />
            <Route path="/admin" element={<Layout><AdminDashboard /></Layout>} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}
